import { formatBodyWeight, formatResultWeight } from '~/utils/weight';
import { Table } from '~/components/Table/Table';
import { CompetitionResult } from '~/apis/ssf';
import { formatPoints } from '~/utils/points';
import { Link } from '~/components/Link/Link';

interface Props {
  results: CompetitionResult[];
  isLoading: boolean;
  isBenchCompetition: boolean;
}

function Row({ result, isBenchCompetition }: { result: CompetitionResult; isBenchCompetition: boolean }) {
  return (
    <Table.Row>
      <Table.Col>
        <Link to={`/lifters/${result.person.id}`}>{`${result.person.first_name} ${result.person.last_name}`}</Link>
      </Table.Col>
      <Table.Col>{formatBodyWeight(result.body_weight)}</Table.Col>
      {!isBenchCompetition && <Table.Col>{result.squat ? formatResultWeight(result.squat) : '-'}</Table.Col>}
      <Table.Col>{result.benchpress ? formatResultWeight(result.benchpress) : '-'}</Table.Col>
      {!isBenchCompetition && <Table.Col>{result.deadlift ? formatResultWeight(result.deadlift) : '-'}</Table.Col>}
      {!isBenchCompetition && <Table.Col>{result.total ? formatResultWeight(result.total) : '-'}</Table.Col>}
      <Table.Col>{formatPoints(result.points ?? 0)}</Table.Col>
    </Table.Row>
  );
}

export function TeamResultListTable({ results, isLoading, isBenchCompetition }: Props) {
  return (
    <Table bg="even">
      <Table.Head>
        <Table.Row>
          <Table.Col as="th">Lyftare</Table.Col>
          <Table.Col as="th">Kroppsvikt</Table.Col>
          {!isBenchCompetition && <Table.Col as="th">Knäböj</Table.Col>}
          <Table.Col as="th">Bänkpress</Table.Col>
          {!isBenchCompetition && <Table.Col as="th">Marklyft</Table.Col>}
          {!isBenchCompetition && <Table.Col as="th">Total</Table.Col>}
          <Table.Col as="th" tooltip="Poängsystem: IPFGL">
            Poäng
          </Table.Col>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {isLoading ? (
          <Table.Loading cols={isBenchCompetition ? 3 : 6} />
        ) : (
          results.map(r => <Row result={r} key={r.id} isBenchCompetition={isBenchCompetition} />)
        )}
      </Table.Body>
    </Table>
  );
}
